import { useEffect } from 'react';
import { useDispatch, useSelector } from 'shared/hooks';
import { sync, SYNC } from 'shared/wizard/actions';
import { Heading, LabelText } from 'shared/components';
import { InputsContainer } from 'shared/containers';
import { SelectInput, CurrencyInput } from 'shared/inputs';
import { SwitchCoverageType } from './';
import analytics from 'shared/utility/analytics';

const NewOrv = () => {
  const dispatch = useDispatch();
  const { output: { errors }, input } = useSelector(state => state);
  
  useEffect(() => {
    dispatch({ type: SYNC, syncing: false });
    analytics.send('Navigeer', 'New ORV pagina');
  }, []);

  return (
    <>
      <Heading>Kies je dekking</Heading>
      <InputsContainer>
        <LabelText>Hoeveel jaar wil je verzekerd zijn (vaak gelijk aan de looptijd van je hypotheek)</LabelText>
        <SelectInput
          name="duration"
          value={input.duration}
          errors={errors.duration}
          placeholder="Looptijd"
          onChange={option => sync(dispatch)('duration', option.value)}
          options={Array.from({length: 58},
            (_, i) => ({ label: `${i + 1} jaar`, value: i + 1 })
          )}
          isSearchable
        />
        <LabelText>Wat wil je dat de verzekeraar uitkeert bij overlijden?</LabelText>
        <CurrencyInput
          name="coverage"
          placeholder="Bedrag"
          value={input.coverage}
          errors={errors.coverage}
          onChange={sync(dispatch)('coverage')}
        />
        <LabelText>Type dekking (klik voor toelichting)</LabelText>
        <SwitchCoverageType />
      </InputsContainer>
    </>
  );
};

export default NewOrv;
